//@flow
import * as React from 'react'
import type { OrionQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const OrionQualityReview=(props:OrionQualityReview$Props)=>{
    const orion = props.orion
    let isVisible = false

    if (orion.reviewQuestions && orion.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'orionQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'orionPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(orion.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default OrionQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectOrion/OrionQualityReview.js